
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Box } from '@mui/material';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { STRIPE_PUBLISHABLE_KEY } from '../../config/stripeConfig';

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);


const CheckoutForm = forwardRef(({ clientSecret, email, onReady }, ref) => {
  const stripe = useStripe();
  const elements = useElements();
  const [processing, setProcessing] = useState(false);

  const handleSubmit = async () => {
    if (!stripe || !elements) return null;

    setProcessing(true);
    try {
      const result = await stripe.confirmPayment({
        elements,
        confirmParams: {
          receipt_email: email,
          return_url: 'https://dev.selnitech.online/payment-completed'
        },
        redirect: 'if_required'
      });
      return result;
    } finally {
      setProcessing(false);
    }
  };

  useImperativeHandle(ref, () => ({
    processPayment: handleSubmit
  }));

  return (
    <Box sx={{ maxWidth: 1000, mx: 'auto' }}>
      <PaymentElement
        options={{
          layout: 'tabs',
          fields: {
            billingDetails: 'auto',
          },
        }} 
        // options={{ layout: 'tabs' }}
        onReady={() => onReady && onReady()}
      />
    </Box>
  );
});

const StripeCheckout = forwardRef(({ clientSecret, email, onReady }, ref) => (
  <Elements stripe={stripePromise} options={{ clientSecret }} onReady={onReady}>
    <CheckoutForm ref={ref} email={email} />
  </Elements>
));

export default StripeCheckout;
